'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('./index.less');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalFooter = function GlobalFooter(_ref) {
  var className = _ref.className,
      links = _ref.links,
      copyright = _ref.copyright;

  return _react2.default.createElement(
    'div',
    { className: _index2.default.globalFooter + ' ' + className },
    copyright && _react2.default.createElement(
      'div',
      { className: _index2.default.copyright },
      copyright
    )
  );
};

GlobalFooter.defaultProps = {
  className: undefined,
  links: undefined,
  copyright: {}
};

GlobalFooter.propTypes = {
  className: _propTypes2.default.string,
  links: _propTypes2.default.string,
  copyright: _propTypes2.default.object
};

exports.default = GlobalFooter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/GlobalFooter/index.js
// module id = 772
// module chunks = 0